import useAppUserPermissions from 'hooks/useAppUserPermissions';

const useSeePropertySettingsAllowed = () => {
  const permissions = useAppUserPermissions();
  return permissions.includes('Properties:Get');
};

export default useSeePropertySettingsAllowed;
